import Input from '@material-ui/core/Input';
import React from 'react';
import { Select, InputLabel } from '@material-ui/core'

const types = [
  "Between",
  "Not in Between",
  "is Equal to (==)",
  "is Greater than (>)",
  "is Greater than or Equal to (>=)",
  "is Lesser than (<)",
  "is Lesser than or Equal to (<=)",
  "is Not Equal to (!=)"
]

export class CaseBlockNumberInput extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <React.Fragment>
        <InputLabel htmlFor="age-native-simple" style={{ marginRight: 10 }}>{this.props.label}</InputLabel>
        <Select
          native
          value={this.props.selectedData && this.props.selectedData.hasOwnProperty('numberType') ?
            this.props.selectedData.numberType : "is Equal to (==)"
          }
          onChange={(e) => {
            this.props.onSelectedData(this.props.filterId, {
              numberType: e.target.value,
              numberData: (this.props.selectedData && this.props.selectedData.hasOwnProperty('numberData')
                && this.props.selectedData.numberData !== undefined
                && this.props.selectedData.numberData.length == 2
              ) ? this.props.selectedData.numberData : [0, 0]
            })
          }}
        >
          {types.map((obj, idx) => {
            return (<option key={idx + obj}>{obj}</option>)
          })}
        </Select>
        <br />
        <Input
          value={
            (this.props.selectedData && this.props.selectedData.hasOwnProperty('numberData')) ?
              this.props.selectedData.numberData[0] : 0
          }
          onChange={(e) => {
            console.log(this.props.selectedData)
            this.props.onSelectedData(this.props.filterId, {
              numberType: (this.props.selectedData && this.props.selectedData.hasOwnProperty('numberType')) ?
                this.props.selectedData.numberType : "is Equal to (==)",
              numberData: (
                this.props.selectedData
                && this.props.selectedData.hasOwnProperty('numberData')
                && this.props.selectedData.numberData !== undefined
                && this.props.selectedData.numberData.length == 2
              ) ? [e.target.value ? e.target.value : null, this.props.selectedData[1]] : [0, 0]
            })
          }}
          type="number"
          placeholder='Number'
          labelWidth={60}
        />
        {this.props.selectedData && this.props.selectedData.hasOwnProperty('numberType') &&
          (this.props.selectedData.numberType == "Between" || this.props.selectedData.numberType == "Not in Between") && (
            <React.Fragment>
              <span
                style={{ marginRight: '10px', marginLeft: '10px' }}
              >and</span>
              <Input
                value={
                  (this.props.selectedData
                    && this.props.selectedData.hasOwnProperty('numberData')) ?
                    this.props.selectedData.numberData[1] : 0
                }
                onChange={(e) => {
                  this.props.onSelectedData(this.props.filterId, {
                    numberType: (this.props.selectedData && this.props.selectedData.hasOwnProperty('numberType')) ?
                      this.props.selectedData.numberType : "is Equal to (==)",
                    numberData: (
                      this.props.selectedData
                      && this.props.selectedData.hasOwnProperty('numberData')
                      && this.props.selectedData.numberData !== undefined
                      && this.props.selectedData.numberData.length == 2
                    ) ? [this.props.selectedData.numberData[0], e.target.value ? e.target.value : null] : [0, 0]
                  }
                  )
                }}
                type="number"
                placeholder='Number'
                labelWidth={60}
              />
            </React.Fragment>
          )}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/dragAndDrop/components/caseBlockNumberInput.jsx